/* Стили */
import '../css/site.scss';

/* Библиотеки */

/* Модальные окна */
import { initModal } from './modules/modal/init-modal.js';

/* Скрипты */
import changeDate from './modules/changeDate.js';
import form from './modules/form.js';
import sliders from './modules/sliders/sliders.js';
import UtmTags from './modules/UtmTags.js';
import { cookieConsentChecker } from './modules/cookies/cookie-consent-checker';
import burger from './modules/burger';
import reviews from './modules/reviews.js';
import initTabs from './modules/init-tabs.js';
import { initAccordion } from './modules/accordion/init-accordion.js';
import seeAll from './modules/seeAll.js';
import initParallax from './modules/init-parallax.js';
import scrollToAnimation from './modules/scrollToAnimation.js';
import hoverAnimation from './modules/hoverAnimation.js';
import homeAnimation from './modules/homeAnimation.js';
import initModals from './modules/modals/init-modals.js';
import bannerBottom from './modules/bannerBottom.js';
import site from './modules/site.js';

document.addEventListener('DOMContentLoaded', () => {
  burger();
  UtmTags();
  changeDate('30 ноября');
  sliders();
  form();
  initModal();
  cookieConsentChecker();
  reviews();
  bannerBottom();
  initTabs();
  site();
  initModals();
  initAccordion();
  seeAll(
    document.querySelector('.program-block__link'),
    document.querySelectorAll('.program__block'),
    'Свернуть программу',
    'Показать всю программу',
    4
  );
  if (window.innerWidth < 1024) {
    seeAll(
      document.querySelector('.faq-block__link'),
      document.querySelectorAll('.faq__block'),
      'Свернуть все...',
      'Показать все...',
      5
    );
  }
  if (window.innerWidth >= 1024) {
    initParallax();
    scrollToAnimation();
    hoverAnimation();
    if (['/'].indexOf(window.location.pathname) >= 0) {
      homeAnimation();
    }
  }
});
